// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Button, Container, Grid, Link, Typography } from '@mui/material';

import MainCard from '../../Components/MainCard';
import Animation from './Animation';

// assets
import { SendOutlined } from '@ant-design/icons';
import AnimateButton from '../../Components/@extended/AnimateButton';

import simplifyImg from '../../assets/landing/simplify343.jpg';
import genaiImg from '../../assets/landing/genai343.jpg';
import upskillingImg from '../../assets/landing/upskilling343.jpg';
import {Link as RouterLink} from "react-router-dom";

const ServicesBlock = () => {
    const theme = useTheme();

    return (
    <Container>
      <Grid container alignItems="center" justifyContent="center" spacing={2} sx={{ mt: { md: 15, xs: 2.5 }, mb: { md: 10, xs: 2.5 } }}>
        <Grid item xs={12}>
          <Grid container spacing={1} justifyContent="center" sx={{ mb: 4, textAlign: 'center' }}>
            <Grid item sm={10} md={6}>
              <Grid container spacing={1} justifyContent="center">
                <Grid item xs={12}>
                  <Typography variant="subtitle1" color="primary">
                    Why Ikigai
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h2" sx={{ mb: 2 }}>
                    Focus on what brings you purpose
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body1">
                    No matter how big or small your business is. Ikigai helps you simplify processes, provide data insights in order to boost productivity.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={4} md={4}>
          <Animation
            variants={{
              visible: { opacity: 1 },
              hidden: { opacity: 0 }
            }}
          >
            <MainCard contentSX={{ p: 3, background: '#f8f9fa' }}>
              <Grid container spacing={1.5}>
                <Grid item xs={12}>
                  <Typography variant="h5" sx={{ fontWeight: 600, mt: 2 }}>
                    Simplify Processes
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body1" color="grey">
                    Standardise your workflow by using templates and technology for automation.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ display: 'inline-block' }}>
                  </Box>
                </Grid>
                <Grid item xs={12} sx={{ '& img': { mb: -3.75, width: `calc( 100% + 24px)` } }}>
                  <img src={simplifyImg} alt="feature" />
                </Grid>
              </Grid>
            </MainCard>
          </Animation>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <Animation
            variants={{
              visible: { opacity: 1 },
              hidden: { opacity: 0 }
            }}
          >
            <MainCard contentSX={{ p: 3, background: '#f8f9fa' }}>
              <Grid container spacing={1.5}>
                <Grid item xs={12}>
                  <Typography variant="h5" sx={{ fontWeight: 600, mt: 2 }}>
                    Improve Productivity
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body1" color="grey">
                    Through simplification and automation, what once was highly manual and time consuming is quick and simple. Freeing up time to focus on more meaningful and valuable priorities.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ display: 'inline-block' }}>
                  </Box>
                </Grid>
                <Grid item xs={12} sx={{ '& img': { mb: -3.75, width: `calc( 100% + 24px)` } }}>
                  <img src={upskillingImg} alt="feature" />
                </Grid>
              </Grid>
            </MainCard>
          </Animation>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <Animation
            variants={{
              visible: { opacity: 1 },
              hidden: { opacity: 0 }
            }}
          >
            <MainCard contentSX={{ p: 3, background: '#f8f9fa' }}>
              <Grid container spacing={1.5}>
                <Grid item xs={12}>
                  <Typography variant="h5" sx={{ fontWeight: 600, mt: 2 }}>
                    Data Analytics
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body1" color="grey">
                    Your business generates high volumes of data. With Ikigai's integration to Xero, it is able to uncover meaningful insights from your data.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ display: 'inline-block' }}>
                  </Box>
                </Grid>
                <Grid item xs={12} sx={{ '& img': { mb: -3.75, width: `calc( 100% + 24px)` } }}>
                  <img src={genaiImg} alt="feature" />
                </Grid>
              </Grid>
            </MainCard>
          </Animation>
        </Grid>
      </Grid>
    </Container>
  );

}

export default ServicesBlock;